'use strict';

/**
 * @ngdoc service
 * @name vTvPackageServices.TvPackageSelectionUpdateService
 * @description Responsible for calling and providing the results of the process-selection API endpoint
 */

angular.module('v-tv-package-services').service('TvPackageSelectionUpdateService', function TvPackageSelectionUpdateService(TvPackageApi, tvPackageConfig, TvPackageChannelsByCategories, TvPackageChannelsHelperService, $cacheFactory, $q) {

    var indexedChannelsCache = new $cacheFactory('SelectionUpdateService');

    /**
     * @ngdoc method
     * @name vTvPackageServices.TvPackageSelectionUpdateService#processCart
     * @methodOf vTvPackageServices.TvPackageSelectionUpdateService
     * @param {vTvPackageServices.TvPackageCart} cart the cart to submit to process selection
     * @param {boolean} isALaCarte true if the provided cart is à la carte
     * @returns {Promise} a Promise that completes when the process-selection call is done and interpreted
     */

    this.processCart = function (cart, isALaCarte) {
        var data = cart.getCartData() || { packageDisplayMode: !isALaCarte, selectedChannels: [] };

        if (!('packageDisplayMode' in data)) {
            data.packageDisplayMode = !isALaCarte;
        }

        return TvPackageApi.doPost(tvPackageConfig.ENDPOINT.PROCESS_SELECTION, null, data, null, true).then(function (response) {
            cart.setIsDisabled(false);
            // Dev purpose only. Rebuild process_selection if a cart is available (overwrite all stub results
            if (tvPackageConfig.IGNORE_PROCESSED_CHANNEL_SELECTION) {
                var cartSelection = cart.getCartData() ? cart.getCartData().selectedChannels : [];
                var categoriesMap = {};

                if (cartSelection && response.data.selection) {
                    // Reset pools displayElement and build a categories map
                    response.data.selection.channelsByCategory.forEach(function (val, idx, arr) {
                        arr[idx].displayElements = [];

                        arr[idx].categoryIds.forEach(function (cat) {
                            categoriesMap[cat] = idx;
                        });
                    });
                }

                return TvPackageChannelsByCategories.getChannelsByCategories().then(function (channelsList) {
                    var channelsIndex = indexedChannelsCache.get('IndexedChannels');
                    var selectionState = response.data;

                    // Build channelsIndex cache
                    if (!channelsIndex) {
                        channelsIndex = TvPackageChannelsHelperService.indexChannelsByIds(channelsList);
                        indexedChannelsCache.put('IndexedChannels', channelsIndex);
                    }

                    // Rebuild pool data with channels information retrieved in channelsCache.
                    if (cartSelection && response.data.selection) {
                        cartSelection.forEach(function (channelId) {
                            var catId = channelsIndex[channelId].vm.categoryId;
                            var channel = channelsIndex[channelId];

                            channel.isValid = channel.vm.categoryState === 'active';
                            if (!channel.isValid) {
                                selectionState.selection.isValid = false;
                            }

                            if (!(catId in categoriesMap)) {
                                catId = Object.keys(categoriesMap)[0];
                            }
                            if (selectionState.selection.channelsByCategory[categoriesMap[catId]].displayElements.indexOf(channel) === -1) {
                                selectionState.selection.channelsByCategory[categoriesMap[catId]].displayElements.push(channel);
                            }
                        });

                        selectionState.selection.channelsByCategory.forEach(function (category) {
                            if (category.rules.isLimited && category.displayElements.length < category.rules.limit) {
                                var len = category.displayElements.length;

                                category.displayElements.length = category.rules.limit;
                                category.displayElements.fill(null, len);
                                category.message = '';
                            } else if (category.rules.isLimited && category.displayElements.length > category.rules.limit) {
                                selectionState.selection.isValid = false;
                            }
                        });
                    }

                    // "randomly" show or the upsale box
                    // selectionState.showUpsale = !(+new Date() % 3);
                    selectionState.showUpsale = false;

                    response.data = selectionState;
                    return response;
                });
            }

            return response;
        }, function (errorResponse) {
            if (errorResponse.status === 400) {
                cart.setIsDisabled(true);
            }
            return $q.reject(errorResponse);
        });
    };
});